import './HeaderAlt.scss';

import React from 'react';

const HeaderAlt = ({ image }) => {
    return (
        <section className="Header__showdown-alt">
            <img
                src={image}
                alt="ESPN De Ontknoping promo afbeelding"
                className="banner-img"
            />
        </section>
    );
};

export default HeaderAlt;
